// Lead domain choices — recreated verbatim from legacy SuiteCRM leads module
// (see LEADS_MODULE_DESIGN.md for the inspected distributions).

export const LEAD_STATUS_CHOICES = [
  { id: "New", name: "New" },
  { id: "Contact Made", name: "Contact Made" },
  { id: "Follow-up", name: "Follow-up" },
  { id: "Possible", name: "Possible" },
  { id: "Not Ready", name: "Not Ready" },
  { id: "Vintage", name: "Vintage" },
  { id: "Planned", name: "Planned" },
  { id: "Held", name: "Held" },
  { id: "Email Discussion", name: "Email Discussion" },
  { id: "No Answer or Busy", name: "No Answer or Busy" },
  { id: "With Competitor", name: "With Competitor" },
  { id: "Dead", name: "Dead" },
  { id: "Doesn’t Qualify", name: "Doesn’t Qualify" },
  { id: "Duplicated", name: "Duplicated" },
  { id: "Converted", name: "Converted" },
];

// Statuses shown by default in list filters ("live pipeline")
export const LEAD_ACTIVE_STATUSES = [
  "New",
  "Contact Made",
  "Follow-up",
  "Possible",
  "Not Ready",
  "Vintage",
  "Planned",
  "Held",
  "Email Discussion",
  "No Answer or Busy",
  "With Competitor",
];

export const LEAD_TERMINAL_STATUSES = [
  "Dead",
  "Doesn’t Qualify",
  "Duplicated",
  "Converted",
];

export const LEAD_TYPE_CHOICES = [
  { id: "Customer", name: "Customer" },
  { id: "Vendor", name: "Vendor" },
  { id: "Both", name: "Both" },
];

export const LEAD_DIRECTION_CHOICES = [
  { id: "Inbound", name: "Inbound" },
  { id: "Outbound", name: "Outbound" },
];

export const LEAD_SOURCE_CHOICES = [
  { id: "Organic Search - Google", name: "Organic Search - Google" },
  { id: "Paid Search - Google", name: "Paid Search - Google" },
  { id: "Cold Call", name: "Cold Call" },
  { id: "Whatsapp", name: "WhatsApp" },
  { id: "Vertical Directory", name: "Vertical Directory" },
  { id: "Referral", name: "Referral" },
  { id: "Social Media - Facebook", name: "Social Media - Facebook" },
  { id: "Social Media - Instagram", name: "Social Media - Instagram" },
  { id: "Social Media - LinkedIn", name: "Social Media - LinkedIn" },
  { id: "Social Media - TikTok", name: "Social Media - TikTok" },
  { id: "Paid Campaign - Social Media", name: "Paid Campaign - Social Media" },
  { id: "Conference", name: "Conference" },
  { id: "Email Marketing", name: "Email Marketing" },
  { id: "Email", name: "Email" },
  { id: "AI Search", name: "AI Search" },
  { id: "Existing Customer", name: "Existing Customer" },
  { id: "Organic", name: "Organic" },
  { id: "Other", name: "Other" },
];

export const LEAD_CHANNEL_CHOICES = [
  { id: "Website", name: "Website" },
  { id: "WhatsApp", name: "WhatsApp" },
  { id: "Email", name: "Email" },
  { id: "Phone", name: "Phone" },
  { id: "Direct Message - Facebook", name: "Direct Message - Facebook" },
  { id: "Direct Message - Instagram", name: "Direct Message - Instagram" },
  { id: "Other", name: "Other" },
];

export const REASON_FOR_DEAD_CHOICES = [
  { id: "other (see notes)", name: "Other (see notes)" },
  { id: "organization too small", name: "Organization too small" },
  { id: "location too remote", name: "Location too remote" },
  {
    id: "disconnected /reassigned number",
    name: "Disconnected / reassigned number",
  },
  {
    id: "buys/sells through regional warehouse",
    name: "Buys/sells through regional warehouse",
  },
  {
    id: "currently buy/sell indirectly",
    name: "Currently buy/sell indirectly",
  },
  { id: "no storage space", name: "No storage space" },
  {
    id: "no loading/unloading facility",
    name: "No loading/unloading facility",
  },
  { id: "cannot load/receive trucks", name: "Cannot load/receive trucks" },
];

export const PREFERRED_LANGUAGE_CHOICES = [
  { id: "English", name: "English" },
  { id: "Spanish", name: "Spanish" },
];

export const COLLECTION_METHOD_CHOICES = [
  { id: "Bin", name: "Bin" },
  { id: "Donation", name: "Donation" },
  { id: "Thrift", name: "Thrift" },
];

export const CAN_LOAD_CHOICES = [
  { id: "truck", name: "Truck" },
  { id: "container", name: "Container" },
  { id: "both", name: "Both" },
  { id: "none", name: "None" },
];
